// @ts-check
// Campanhas > Modelos (/campaigns/templates?tab=email|whatsapp; spec-2.0.0 seção 4.10; contrato 09 de campanhas base):
// casca com as abas E-mail e WhatsApp, cada uma só com a flag dela. O conteúdo de cada aba é da área dona:
// EmailTemplatesTab (frente 1C) e WhatsappTemplatesTab (frente 1D). A aba fica na URL.
import { html } from 'htm/preact';
import { searchParamsState, updateSearchParams } from '../../app/router.js';
import { hasCurrentPermissionFlag } from '../../data/metadata-store.js';
import { PageCard, PageHeader } from '../page/page-card.js';
import { TabList } from '../../ui/tab-list.js';
import { t } from '../../i18n/index.js';
import { resolveCampaignTemplateTab, visibleCampaignTemplateTabs } from '../../../../shared/navigation/screen-access.js';
import { EmailTemplatesTab } from '../email/email-templates-tab.js';
import { WhatsappTemplatesTab } from '../campaign-templates/whatsapp-templates-tab.js';
import { CampaignsNoAccess } from './campaigns-no-access.js';

export function CampaignTemplatesPage() {
  const tabs = visibleCampaignTemplateTabs(hasCurrentPermissionFlag);
  const activeTab = resolveCampaignTemplateTab(searchParamsState.value.get('tab'), hasCurrentPermissionFlag);
  if (!activeTab) return html`<${CampaignsNoAccess} screenKey="templates" />`;
  return html`<${PageCard}
    className="campaigns-screen campaign-templates-page"
    header=${html`<${PageHeader} icon="IconLayoutGrid" title=${t('campaignsBase.templates.title')} />`}
  >
    <div class="campaign-templates-tabs" aria-label=${t('campaignsBase.templates.tabsLabel')}>
      <${TabList}
        tabs=${tabs.map((tab) => ({ id: tab.key, title: t(tab.labelKey), icon: tab.icon }))}
        activeTabId=${activeTab}
        onChange=${(tabId) => updateSearchParams({ tab: tabId })}
      />
    </div>
    <div class="campaign-templates-content" role="tabpanel" aria-labelledby=${`tab-${activeTab}`}>
      ${activeTab === 'email' ? html`<${EmailTemplatesTab} />` : html`<${WhatsappTemplatesTab} />`}
    </div>
  <//>`;
}
